import { BrowserRouter, Routes, Route } from "react-router-dom";
import ResumePage from "./pages/ResumePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ResumePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
